module.exports = __webpack_public_path__ + "static/media/onestop_img3.dc526bdd.jpg";